import api from "./config";

export const usersAPI = {
  createUser: async (userData) => {
    try {
      const response = await api.post("/users", userData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "Failed to create user",
      };
    }
  },

  getUsers: async () => {
    try {
      const response = await api.get("/users");
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "Failed to get users",
      };
    }
  },

  getClients: async () => {
    try {
      const response = await api.get("/users/clients");
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "Failed to get clients",
      };
    }
  },

  deleteUser: async (userId) => {
    try {
      const response = await api.delete(`/users/${userId}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "Failed to delete user",
      };
    }
  },

  updateUser: async (userId, userData) => {
    try {
      const response = await api.patch(`/users/${userId}`, userData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "Failed to update user",
      };
    }
  },

  updateUserPassword: async (userId, data) => {
    try {
      const response = await api.patch(`/users/${userId}/password`, data);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "Failed to update password",
      };
    }
  },
  
  getProfile: async () => {
    try {
      const response = await api.get("/users/me");
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || "Failed to get profile" };
    }
  },

  updateProfile: async (data) => {
    try {
      const response = await api.put("/users/me", data);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || "Failed to update profile" };
    }
  },

  changePassword: async (data) => {
    try {
      const response = await api.put("/users/change-password", data);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || "Failed to change password" };
    }
  },

  updateSubscription: async (subscription) => {
    try {
      const response = await api.put(`/users/subscription`, { subscription });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Failed to update subscription",
      };
    }
  },
};
